import { useParams } from 'react-router-dom';

import { AppCategoryPage } from '~/components/pages/AppCategoryPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppCategoryRoute: React.FC = () => {
  const { appId, categoryId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  if (!categoryId) {
    return <Navigate to={`/apps/${appId}/content`} />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCategoryPage appId={appId} categoryId={categoryId} />
    </DashboardTemplate>
  );
};
